import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'device_brand': 'String',
	'device_name': 'String',
	'platform': 'String',
	'platform_version': 'String',
	'app_version': 'String',
	'build_version': 'String',
}

export default gql(`
	mutation employee_version( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_version( ${ HelperGraphql.createVariables( fields ) } ) {
	        device_brand
	        device_name
	        platform
	        platform_version
	        app_version
	        build_version
	    }
	}
`);

